import { Route, Routes } from "react-router-dom";

import type QueryClient from "../../api/query/queryClient";
import { FEATURE_FLAG_KEYS, useFeatureFlag } from "../../utils/featureFlags";
import PageNotFound from "../PageNotFound";
import MetabaseView from "./MetabaseView";

interface ReportsDashboardProps {
  queryClient: QueryClient;
  selectedPractices: PracticeMessage[];
  organization: OrganizationMessage | null;
}

export default function ReportsDashboard({
  queryClient,
  selectedPractices,
  organization,
}: ReportsDashboardProps) {
  const { isEnabled: isReportsEnabled, isLoading } = useFeatureFlag(
    FEATURE_FLAG_KEYS.REPORTS,
  );
  if (isLoading || !isReportsEnabled) {
    return <PageNotFound />;
  }
  return (
    <Routes>
      <Route
        path="/"
        element={
          <MetabaseView
            queryClient={queryClient}
            selectedPractices={selectedPractices}
            organization={organization}
          />
        }
      />
    </Routes>
  );
}
